import React from 'react';

import RenderIfVisible from 'react-render-if-visible'

import MessageImage from "./MessageImage";
import MessageAudio from "./MessageAudio";
import MessageVideo from "./MessageVideo";

// icons
import MessagePDF from "./MessagePDF";
import MessageCommonAttachment from "./MessageCommonAttachment";


class MessageAttachment extends React.Component {
    render() {
        switch (this.props.message.extension) {
            case 'png':
            case 'jpg':
            case 'jpeg':
            case 'bmp':
            case 'webp':
            case 'gif':
            case 'avif':
            case 'svg':
            case 'tiff':
                return (
                    <RenderIfVisible
                        defaultHeight={15}
                        stayRendered={true}
                    >
                        <MessageImage
                            message={this.props.message}
                            hideModal={this.props.hideModal}
                        />
                    </RenderIfVisible>
                )
            case 'mp3':
            case 'wav':
            case 'aac':
            case 'webm':
            case 'ogg':
            case 'm4a':
                return(
                    <MessageAudio
                        message={this.props.message}
                    />
                )
            case 'mp4':
            case 'avi':
                return(
                    <MessageVideo
                        message={this.props.message}
                    />
                )
            case 'pdf':
            case 'doc':
            case 'docx':
                return(
                    <MessagePDF
                        message={this.props.message}
                    />
                )
            default:
                return (
                    <MessageCommonAttachment
                        message={this.props.message}
                    />
                )
        }
    }
}

export default MessageAttachment

